import { Button } from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC } from 'react'
import { getImageSrc } from '../../../../../helpers/getImageSrc'
import { createServiceRequestStore } from '../stores/NewCreateServiceRequestStore'

interface SuccessSearchResultButtonsProps {
  onBack: () => void
  createMode?: boolean
  forbidCreating?: boolean
  onClose: () => void
}

const SuccessSearchResultButtons: FC<SuccessSearchResultButtonsProps> = ({
  onBack,
  createMode,
  forbidCreating,
  onClose,
}) => {
  const {
    selectedRequest,
    setIsShowAllRequestsDrawerOpen,
    setIsResultsDrawerOpen,
    setIsCreateDrawerOpen,
  } = createServiceRequestStore

  const onCreateBtnClick = () => {
    setIsResultsDrawerOpen(false)
    if (createMode) {
      setIsShowAllRequestsDrawerOpen(false)
      setIsCreateDrawerOpen(true)
    } else {
      setIsShowAllRequestsDrawerOpen(true)
    }
  }

  return (
    <>
      {!forbidCreating && (
        <Button
          variant='contained'
          disabled={!selectedRequest}
          onClick={onCreateBtnClick}
        >
          {!createMode
            ? 'продолжить'
            : `создать на основе заявки 
        ${selectedRequest?.orderId && `№${selectedRequest?.orderId}`}`}
        </Button>
      )}
      {forbidCreating && (
        <Button
          variant='contained'
          disabled={!selectedRequest}
          onClick={onClose}
        >
          Завершить звонок
        </Button>
      )}
      <Button variant='outlined' onClick={onBack}>
        <img
          alt={'Назад'}
          src={getImageSrc('arrow-left-blue')}
          style={{ marginRight: '4px' }}
        />
        {createMode ? 'Назад' : 'Вернуться к поиску'}
      </Button>
    </>
  )
}

export default observer(SuccessSearchResultButtons)
